<template>
  <img :src="logoUrl" alt="FormBeat - Advanced Cycling Analytics" width="148" />
</template>

<script>
const logoUrl = require('images/formbeat-logo.svg')
const logoLightUrl = require('images/formbeat-logo-light.svg')
const signUrl = require('images/formbeat-sign.svg')
export default {
  props: {
    sign: {
      type: Boolean,
      required: false,
      default: false
    },
    light: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    logoUrl() {
      return this.light ? (this.sign ? signUrl : logoLightUrl) : this.sign ? signUrl : logoUrl
    }
  }
}
</script>
